// W-0821 — Modal para escolher cobrador e atribuir a 1 ou N boletos.
// Lookup de cobradores já vem filtrado por nível (pezao/sojuris) do response do backend.

import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import Select from 'react-select';
import { Formik } from 'formik';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import { atribuirCobradorSchema } from '../validationSchemas';

const ModalAtribuirCobrador = ({
  show,
  codigosBoleto,
  cobradores, // [{ codigo, nome, tipo }]
  onConfirmar,
  onCancelar,
}) => {
  const opcoes = (cobradores || []).map((c) => ({
    value: c.codigo,
    label: `${c.codigo} — ${c.nome}`,
  }));

  const qtd = codigosBoleto ? codigosBoleto.length : 0;

  return (
    <Modal show={show} onHide={onCancelar} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Atribuir cobrador{' '}
          {qtd > 1 ? `a ${qtd} boletos` : qtd === 1 ? 'ao boleto' : ''}
        </Modal.Title>
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={{ cobradorCodigo: null }}
        validationSchema={atribuirCobradorSchema}
        onSubmit={(valores) =>
          onConfirmar(codigosBoleto, valores.cobradorCodigo)
        }
      >
        {({ values, errors, touched, setFieldValue, handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Modal.Body>
              <Form.Group>
                <Form.Label className="small mb-1">Cobrador</Form.Label>
                <Select
                  styles={customStyles}
                  components={{ DropdownIndicator }}
                  placeholder="Selecione um cobrador..."
                  options={opcoes}
                  value={
                    opcoes.find((o) => o.value === values.cobradorCodigo) || null
                  }
                  onChange={(opt) =>
                    setFieldValue('cobradorCodigo', opt ? opt.value : null)
                  }
                  noOptionsMessage={() =>
                    'Nenhum cobrador disponível para o seu nível de acesso'
                  }
                />
                {touched.cobradorCodigo && errors.cobradorCodigo && (
                  <Form.Text className="text-danger">
                    {errors.cobradorCodigo}
                  </Form.Text>
                )}
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={onCancelar}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Atribuir
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalAtribuirCobrador;
